<template>
  <div class="help-center-login">
    <content-loader :loading="true" />
  </div>
</template>

<script>
// Login URL of the Zoho Desk help center web portal: Zoho sends the user here with return_to, and
// the user is signed in to the portal with the Manager session (or after logging in to the Manager)
import contentLoader from "@/flit2go-web-core/components/base/content-loader.vue";
import zohoDeskAsap from "@/flit2go-web-core/services/zohoDeskAsapService.js";

export default {
  name: "HelpCenterLogin",
  components: {
    "content-loader": contentLoader,
  },
  created() {
    zohoDeskAsap.redirectToHelpCenterPortal(this.getReturnTo());
  },
  methods: {
    // With the hash router, Zoho may append return_to after the hash or before it
    getReturnTo() {
      return (
        this.$route.query.return_to ||
        new URLSearchParams(window.location.search).get("return_to")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.help-center-login {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
